import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import LabelSectionBold from 'components/sections/LabelSectionBold';
import ActionBarDetailWrapper from 'components/wrappers/pages/ActionBarDetailWrapper';
import * as actTableManagement from 'actions/tableManagement';
import moment from 'moment';
import styles from './style.css';

class ReportForm extends React.Component {
  render() {
    const { isSubmittingForm, reportDetail } = this.props;

    if (!reportDetail) {
      return <div />;
    }

    let activeStyle = styles['rounded-cancelled'];
    if (reportDetail.status === 'COMPLETE') {
      activeStyle = styles['rounded-completed'];
    }
    const duration = moment(reportDetail.updatedAt).diff(
      moment(reportDetail.createdAt),
      'minutes'
    );
    const tableNames = reportDetail.tables.map((table, index) => (
      <li key={index}>
        {table.tableGroupName} - {table.tableName}
      </li>
    ));

    return (
      <form className={styles.wrapper}>
        <div className={`${styles['field-wrapper']} table-report-wrapper`}>
          <div className="row">
            <div className="col-sm-12">
              <LabelSectionBold title="Order Details" />
            </div>
          </div>
          <div className="row mb-20px">
            <div className="col-sm-6">Status</div>
            <div className="col-sm-6">
              <span className="pull-right">
                <span className={`${activeStyle}`}>
                  {reportDetail.status === 'COMPLETE'
                    ? 'Completed'
                    : 'Cancelled'}
                </span>
              </span>
            </div>
          </div>
          <div className="row mb-20px">
            <div className="col-sm-6">Order ID</div>
            <div className="col-sm-6">
              <span className="pull-right">{reportDetail.orderId}</span>
            </div>
          </div>

          {reportDetail.status !== 'COMPLETE' && (
            <div className="row mb-20px">
              <div className="col-sm-6">Cancelled Reason</div>
              <div className="col-sm-6">
                <span className="pull-right">
                  {reportDetail.cancelledReason}
                </span>
              </div>
            </div>
          )}
          {reportDetail.status !== 'COMPLETE' && (
            <div className="row mb-20px">
              <div className="col-sm-6">Cancelled By</div>
              <div className="col-sm-6">
                <span className="pull-right">
                  {reportDetail.cancelledByName}
                </span>
              </div>
            </div>
          )}
          {reportDetail.status !== 'COMPLETE' && (
            <div className="row mb-20px">
              <div className="col-sm-6">Cancelled Time</div>
              <div className="col-sm-6">
                <span className="pull-right">
                  {moment(reportDetail.cancelledAt).format('DD MMM YYYY HH:mm')}
                </span>
              </div>
            </div>
          )}
          {reportDetail.status === 'COMPLETE' && (
            <div className="row mb-20px">
              <div className="col-sm-6">Receipt Number</div>
              <div className="col-sm-6">
                <span className="pull-right">{reportDetail.receiptNo}</span>
              </div>
            </div>
          )}
          {reportDetail.status === 'COMPLETE' && (
            <div className="row mb-20px">
              <div className="col-sm-6">Completed Time</div>
              <div className="col-sm-6">
                <span className="pull-right">
                  {moment(reportDetail.updatedAt).format('DD MMM YYYY HH:mm')}
                </span>
              </div>
            </div>
          )}
          <div className="row mb-20px">
            <div className="col-sm-6">Table</div>
            <div className="col-sm-6">
              <span className="pull-right">{tableNames}</span>
            </div>
          </div>
          <div className="row mb-20px">
            <div className="col-sm-6">Served By</div>
            <div className="col-sm-6">
              <span className="pull-right">{reportDetail.serveByName}</span>
            </div>
          </div>
          <div className="row mb-20px">
            <div className="col-sm-6">Pax</div>
            <div className="col-sm-6">
              <span className="pull-right">{reportDetail.pax}</span>
            </div>
          </div>
          <div className="row mb-20px">
            <div className="col-sm-6">Duration</div>
            <div className="col-sm-6">
              <span className="pull-right">{duration} Min</span>
            </div>
          </div>
          <div className={styles.spacer} />

          <div className="row">
            <div className="col-sm-12">
              <LabelSectionBold title="Ordered Items" />
            </div>
          </div>
          <div className="row mb-20px">
            <div className="col-sm-8">Items</div>
            <div className="col-sm-4 text-center">Quantity</div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="panel panel-default">
                <table className="table table-bordered">
                  {reportDetail.orderItem.length > 0 && (
                    <tbody>
                      {reportDetail.orderItem.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td className="col-sm-8">{item.itemName}</td>
                            <td className="col-sm-4 text-center">
                              {item.itemCount}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  )}
                  {reportDetail.orderItem.length === 0 && (
                    <tbody>
                      <tr>
                        <td colspan="2" className="col-sm-12">
                          No Item Found
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </div>
          <div className={styles.spacer} />

          <div className="row">
            <div className="col-sm-12">
              <LabelSectionBold title="Void Items" />
            </div>
          </div>
          <div className="row mb-20px">
            <div className="col-sm-4">Items</div>
            <div className="col-sm-1 text-center">Qty</div>
            <div className="col-sm-4 ">Reason</div>
            <div className="col-sm-3">Executed By</div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="panel panel-default">
                <table className={'table table-bordered table-fixed'}>
                  {reportDetail.cancelledItem.length > 0 && (
                    <tbody>
                      {reportDetail.cancelledItem.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td className="col-sm-4">{item.itemName}</td>
                            <td className="col-sm-1 text-center wrap-text">
                              {item.itemCount}
                            </td>
                            <td className="col-sm-4 wrap-text">
                              {' '}
                              {item.cancelledReason}{' '}
                            </td>
                            <td className="col-sm-3">{item.cancelledByName}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  )}
                  {reportDetail.cancelledItem.length === 0 && (
                    <tbody>
                      <tr>
                        <td colspan="2" className="col-sm-12">
                          No Item Found
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
        <ActionBarDetailWrapper>
          <span className="pull-right">
            <button
              type="button"
              className={`btn btn-primary ${styles['btn-save']}`}
              onClick={this._onClickDone}
              disabled={isSubmittingForm}
            >
              Done
            </button>
          </span>
        </ActionBarDetailWrapper>
      </form>
    );
  }

  _onClickDone = event => {
    const { dispatch } = this.props;
    dispatch(actTableManagement.onReportsClickCancel());
    event.preventDefault();
    event.stopPropagation();
  };
}

const selector = formValueSelector('table-management-report');

const mapForm = {
  form: 'table-management-report',
  touchOnBlur: false,
  touchOnChange: true,
};

function mapStateToProps(state) {
  const {
    reports,
    reportDetail,
    isSubmittingForm,
  } = state.tableManagement.report;
  return {
    reports,
    reportDetail,
    isSubmittingForm,
    report: { id: selector(state, 'id') },
    data: {
      form: state.form,
    },
  };
}

export default reduxForm(mapForm)(connect(mapStateToProps)(ReportForm));
